import { createSelector } from 'reselect';

import { getCoworkingOffersSelector } from './getCoworkingOffersSelector';

export const getCoworkingOffersAvailable = createSelector(getCoworkingOffersSelector, offers => !!offers.length);
